export const pitchTranslations = {
  zh: {
    // Navigation
    nav_home: "首頁",
    nav_problem: "市場痛點",
    nav_solution: "解決方案",
    nav_market: "市場機會",
    nav_business: "商業模式",
    nav_competitive: "競爭優勢",
    nav_ecosystem: "夥伴生態",
    nav_financial: "財務預測",
    nav_team: "團隊介紹",
    nav_cta: "立即投資",

    // Hero Section
    hero_title: "靠著聲音數據銷售賺錢的 AI 英文訓練平台",
    hero_subtitle: "nicetone.ai 是接近免費但有飛輪效應的革命性平台，結合 Microsoft Azure 語音技術與自主 AI 分析，透過用戶聲音數據變現形成可持續成長：更多用戶 → 更多數據 → 更高收入 → 更低成本 → 吸引更多用戶。",
    hero_button_primary: "體驗產品",
    hero_button_secondary: "查看投資機會",

    // Key Metrics
    metric_1_number: "$60B",
    metric_1_label: "全球語言學習市場規模",
    metric_2_number: "$125M",
    metric_2_label: "三年目標年營收",
    metric_3_number: "18%",
    metric_3_label: "數據銷售貢獻營收佔比",
    metric_4_number: "300%",
    metric_4_label: "預期投資報酬率 ROI",

    // Problem Statement
    problem_title: "市場痛點分析",
    problem_subtitle: "當前英語發音學習市場面臨的核心挑戰與未被滿足的需求",
    problem_points: [
      {
        title: "傳統學習效率低落",
        description: "缺乏個人化回饋和科學評估，學習者難以自我診斷音素錯誤",
        details: [
          "無法即時提供精確的發音評估",
          "缺乏音素級別的錯誤分析",
          "學習者難以自我診斷發音問題",
          "傳統教學無法因材施教"
        ]
      },
      {
        title: "專業資源稀缺且成本高昂",
        description: "優質的發音教學資源難以取得，專業指導成本過高",
        details: [
          "專業發音教師資源短缺",
          "一對一指導成本昂貴",
          "地理位置限制學習機會",
          "缺乏標準化評估工具"
        ]
      },
      {
        title: "全球語言學習者流失率高",
        description: "市場流失率高達 50%，需求未被滿足，急需創新解決方案",
        details: [
          "學習動機難以維持",
          "學習效果難以量化",
          "缺乏社群支持與互動",
          "學習成本效益不佳"
        ]
      }
    ],

    // Solution
    solution_title: "創新解決方案",
    solution_subtitle: "全方位的 AI 發音學習平台，基於 Microsoft Azure 語音服務和自主 AI 算法",
    solution_features: [
      {
        title: "智慧發音評估引擎",
        description: "四維度評分系統提供專業級評估與即時回饋",
        benefits: [
          "準確度、流暢度、完整度、韻律四維度評分",
          "音素級精確分析與錯誤定位",
          "即時回饋與個人化改進建議",
          "支援多種口音和方言評估"
        ]
      },
      {
        title: "AI 個人化學習助理",
        description: "智慧分析學習歷程，提供動態內容推薦與錯誤模式識別",
        benefits: [
          "多模態輸入支援（文字、語音、圖片）",
          "動態學習內容生成與推薦",
          "錯誤模式識別與追蹤分析",
          "個人化學習路徑規劃"
        ]
      },
      {
        title: "雲端協作學習生態",
        description: "跨裝置同步與社群分享，打造完整學習生態系統",
        benefits: [
          "跨裝置無縫同步學習進度",
          "社群分享與互動學習",
          "企業級管理和分析工具",
          "收藏系統與學習記錄"
        ]
      },
      {
        title: "創新教育整合模式",
        description: "以學習歷程取代單次考試，支援 API 整合至 LMS 系統",
        benefits: [
          "無縫嵌入各種教學平台",
          "學習歷程追蹤與認證",
          "教師管理後台與分析報告",
          "API 整合與客製化功能"
        ]
      },
      {
        title: "聲音數據變現系統",
        description: "用戶同意數據匿名化用於 AI 訓練，換取免費使用權",
        benefits: [
          "高品質聲音數據收集與處理",
          "匿名化保護用戶隱私",
          "GDPR 合規的數據處理",
          "飛輪效應創造持續價值"
        ]
      }
    ],

    // Market Opportunity
    market_title: "龐大市場機會",
    market_subtitle: "全球語言學習市場規模達 60 億美元，數位學習趨勢提供龐大機會",
    market_segments: [
      {
        title: "全球語言學習市場",
        description: "市場規模 60 億美元，目標服務 5,000 萬用戶",
        metrics: [
          { value: "$60B", label: "全球市場規模" },
          { value: "5,000萬", label: "目標服務用戶" },
          { value: "30,000", label: "目標企業客戶" },
          { value: "20%", label: "目標市場佔有率" }
        ]
      },
      {
        title: "全球擴展計畫",
        description: "支援 34 種語言，10 年內達到 1,000 萬活躍用戶",
        metrics: [
          { value: "34種", label: "支援語言數量" },
          { value: "1,000萬", label: "活躍用戶目標" },
          { value: "$1.5B", label: "年營收目標" },
          { value: "10年", label: "全球佈局時程" }
        ]
      },
      {
        title: "AI 教育市場趨勢",
        description: "COVID 後數位學習成長 30%，AI 教育需求預計達 600 億美元",
        metrics: [
          { value: "$600B", label: "AI 教育市場預估" },
          { value: "30%", label: "疫後數位學習成長" },
          { value: "50%", label: "傳統學習者流失率" },
          { value: "20%", label: "年用戶成長率預估" }
        ]
      }
    ],

    // Business Model
    business_title: "創新商業模式",
    business_subtitle: "聲音數據變現讓平台接近免費，形成飛輪效應的可持續成長模式",
    business_models: [
      {
        title: "B2C 訂閱服務",
        description: "$10/月，高使用免費條款（需符合數據品質要求）",
        pricing: "$10 USD/月",
        details: "超過 5 小時使用且平均 80 分以上可免費，數據用於 AI 訓練"
      },
      {
        title: "B2B 企業解決方案",
        description: "企業員工培訓，1000 小時高品質數據可退費",
        pricing: "$3,000 USD/年起",
        details: "客製化功能、管理後台、分析報告，達標可全額退費"
      },
      {
        title: "教學 API 整合服務",
        description: "$6/月/學生，5 小時高品質數據可 100% 退費",
        pricing: "$6 USD/月/學生",
        details: "教師獲得點數回扣，無縫嵌入 LMS 系統"
      },
      {
        title: "White Label 授權",
        description: "品牌客製化解決方案，1000 小時數據可退費",
        pricing: "$3,000 USD/年起",
        details: "品牌客製、技術支援、共同開發"
      },
      {
        title: "聲音數據銷售",
        description: "niche 語料銷售，每小時 100-500 USD",
        pricing: "$100-500/小時",
        details: "匿名化錯誤發音數據，版稅或一次性銷售模式"
      }
    ],

    // Competitive Advantage
    competitive_title: "核心競爭優勢",
    competitive_subtitle: "數據驅動生態系統創造獨特護城河，形成難以複製的競爭優勢",
    competitive_advantages: [
      {
        title: "技術壁壘與整合優勢",
        description: "Azure 深度整合、自主 AI 算法、34 種語言支援",
        points: [
          "Microsoft Azure 深度整合與優化",
          "自主研發多模態 AI 算法",
          "34 種語言框架，可擴展至 180+ 國",
          "模組化平台設計確保可擴展性"
        ]
      },
      {
        title: "數據變現護城河",
        description: "獨特的聲音數據銷售模式，創造可持續收入來源",
        points: [
          "高品質 niche 錯誤發音數據收集",
          "匿名化處理符合隱私法規",
          "與 AI 公司建立數據銷售夥伴關係",
          "飛輪效應：免費用戶 → 數據 → 收入 → 更多用戶"
        ]
      },
      {
        title: "用戶體驗與生態優勢",
        description: "直覺介面、個人化學習路徑、社群互動與退費激勵",
        points: [
          "直覺易用的跨平台介面設計",
          "個人化學習路徑與智慧推薦",
          "社群分享與協作學習機制",
          "退費激勵機制提升用戶參與度"
        ]
      }
    ],

    // Partner Ecosystem
    ecosystem_title: "策略夥伴生態系統",
    ecosystem_subtitle: "建立多贏合作模式，擴大數據收集與市場觸及",
    ecosystem_partners: [
      {
        title: "教育機構合作",
        description: "學習歷程評估制度，創造三贏合作模式",
        benefits: [
          "$3-4/月/人的學習歷程方案",
          "提供完整學習進度追蹤",
          "認證費用與數據收集雙重獲利",
          "幫助機構提升教學品質"
        ],
        revenue_model: "$3-4/月/人 + 認證費 + 數據銷售"
      },
      {
        title: "API 合作夥伴",
        description: "教師嵌入工具，含點數商城激勵機制",
        benefits: [
          "無縫嵌入各種 LMS 教學系統",
          "教師點數回扣激勵採用",
          "學生家長付費，老師獲得獎勵",
          "提升平台採用率 20%"
        ],
        revenue_model: "$6/月/學生 + 教師點數激勵"
      },
      {
        title: "留學/移民代辦聯盟",
        description: "15-30% 佣金分潤 + 智慧推薦系統",
        benefits: [
          "智慧推薦適合的代辦服務",
          "提升考試通過率增加客戶滿意度",
          "佣金分潤創造被動收入",
          "數據支援精準行銷"
        ],
        revenue_model: "15-30% 佣金 + 平台使用費"
      },
      {
        title: "AI 公司夥伴",
        description: "與 speechsuper.com 等建立數據銷售合作",
        benefits: [
          "高品質 niche 語料銷售合作",
          "版稅或一次性銷售模式",
          "覆蓋 Azure API 成本",
          "建立長期數據供應關係"
        ],
        revenue_model: "數據銷售版稅 + 技術授權"
      }
    ],

    // Financial Projections
    financial_title: "財務成長預測",
    financial_subtitle: "基於保守估計的三年財務藍圖，數據銷售貢獻 18% 營收",
    financial_projections: [
      {
        year: "第一年（啟動期）",
        description: "建立用戶基礎，啟動數據收集與銷售機制",
        metrics: [
          { value: "$12M", label: "總營收" },
          { value: "10萬", label: "用戶數" },
          { value: "$1.5M", label: "數據銷售收入" },
          { value: "25%", label: "淨利潤率" }
        ]
      },
      {
        year: "第二年（成長期）",
        description: "擴大市場觸及，優化數據變現模式",
        metrics: [
          { value: "$44M", label: "總營收" },
          { value: "30萬", label: "用戶數" },
          { value: "$9M", label: "數據銷售收入" },
          { value: "43%", label: "淨利潤率" }
        ]
      },
      {
        year: "第三年（擴張期）",
        description: "全球擴展，確立市場領導地位",
        metrics: [
          { value: "$125M", label: "總營收" },
          { value: "100萬", label: "用戶數" },
          { value: "$41M", label: "數據銷售收入" },
          { value: "50%", label: "淨利潤率" }
        ]
      }
    ],

    // Team
    team_title: "創業團隊",
    team_subtitle: "由 AI 專家、語音工程師和教育創新者組成，具備豐富產品開發經驗",
    team_education_label: "背景：",
    team_experience_label: "經驗：",
    team_members: [
      {
        name: "王意騏 (Yichi Wang)",
        role: "創辦人暨執行長",
        education: "AI 專家、語音技術專家",
        experience: "語言學習 App 開發經驗，AI 語音評估功能創新者"
      }
    ],

    // Call to Action
    cta_title: "投資 AI 教育革命",
    cta_subtitle: "nicetone.ai 不僅是學習平台，更是數據驅動的教育生態系統。投資我們，即投資未來教育科技的千億市場機會！",
    cta_button_primary: "立即體驗產品",
    cta_button_secondary: "聯繫投資洽談"
  },

  en: {
    // Navigation
    nav_home: "Home",
    nav_problem: "Problems",
    nav_solution: "Solutions",
    nav_market: "Market",
    nav_business: "Business",
    nav_competitive: "Advantages",
    nav_ecosystem: "Ecosystem",
    nav_financial: "Financials",
    nav_team: "Team",
    nav_cta: "Invest Now",

    // Hero Section
    hero_title: "AI English Training Platform Monetizing Voice Data",
    hero_subtitle: "nicetone.ai is a near-free platform with flywheel effects, combining Microsoft Azure speech technology with proprietary AI analysis. Monetizing user voice data creates sustainable growth: More Users → More Data → Higher Revenue → Lower Costs → Attract More Users.",
    hero_button_primary: "Try Product",
    hero_button_secondary: "Investment Opportunity",

    // Key Metrics
    metric_1_number: "$60B",
    metric_1_label: "Global Language Learning Market",
    metric_2_number: "$125M",
    metric_2_label: "3-Year Revenue Target",
    metric_3_number: "18%",
    metric_3_label: "Data Sales Revenue Contribution",
    metric_4_number: "300%",
    metric_4_label: "Expected ROI",

    // Problem Statement
    problem_title: "Market Pain Points",
    problem_subtitle: "Core challenges and unmet needs in the current English pronunciation learning market",
    problem_points: [
      {
        title: "Low Traditional Learning Efficiency",
        description: "Lack of personalized feedback and scientific assessment, learners struggle with phoneme error self-diagnosis",
        details: [
          "Unable to provide precise real-time pronunciation assessment",
          "Lack of phoneme-level error analysis",
          "Learners struggle with pronunciation problem self-diagnosis",
          "Traditional teaching cannot cater to individual needs"
        ]
      },
      {
        title: "Scarce and Expensive Professional Resources",
        description: "Quality pronunciation teaching resources are difficult to obtain, professional guidance is costly",
        details: [
          "Shortage of professional pronunciation teachers",
          "Expensive one-on-one guidance",
          "Geographic limitations restrict learning opportunities",
          "Lack of standardized assessment tools"
        ]
      },
      {
        title: "High Global Language Learner Dropout Rate",
        description: "Market dropout rate up to 50%, unmet demand requires innovative solutions",
        details: [
          "Difficult to maintain learning motivation",
          "Hard to quantify learning outcomes",
          "Lack of community support and interaction",
          "Poor learning cost-effectiveness"
        ]
      }
    ],

    // Solution
    solution_title: "Innovative Solutions",
    solution_subtitle: "Comprehensive AI pronunciation learning platform based on Microsoft Azure speech services and proprietary AI algorithms",
    solution_features: [
      {
        title: "Smart Pronunciation Assessment Engine",
        description: "Four-dimensional scoring system providing professional-grade assessment and real-time feedback",
        benefits: [
          "Accuracy, fluency, completeness, prosody four-dimensional scoring",
          "Phoneme-level precise analysis and error localization",
          "Real-time feedback and personalized improvement suggestions",
          "Support for various accents and dialect assessments"
        ]
      },
      {
        title: "AI Personalized Learning Assistant",
        description: "Intelligently analyzes learning progress, provides dynamic content recommendations and error pattern recognition",
        benefits: [
          "Multi-modal input support (text, voice, images)",
          "Dynamic learning content generation and recommendations",
          "Error pattern recognition and tracking analysis",
          "Personalized learning path planning"
        ]
      },
      {
        title: "Cloud Collaborative Learning Ecosystem",
        description: "Cross-device synchronization and community sharing, creating a complete learning ecosystem",
        benefits: [
          "Seamless cross-device learning progress synchronization",
          "Community sharing and interactive learning",
          "Enterprise-level management and analysis tools",
          "Favorite system and learning records"
        ]
      },
      {
        title: "Innovative Educational Integration Model",
        description: "Replace single exams with learning progress, support API integration into LMS systems",
        benefits: [
          "Seamlessly embed into various teaching platforms",
          "Learning progress tracking and certification",
          "Teacher management dashboard and analysis reports",
          "API integration and customization features"
        ]
      },
      {
        title: "Voice Data Monetization System",
        description: "Users consent to anonymized data for AI training in exchange for free usage rights",
        benefits: [
          "High-quality voice data collection and processing",
          "Anonymization protects user privacy",
          "GDPR-compliant data processing",
          "Flywheel effect creates continuous value"
        ]
      }
    ],

    // Market Opportunity
    market_title: "Massive Market Opportunity",
    market_subtitle: "Global language learning market worth $60 billion, digital learning trends provide enormous opportunities",
    market_segments: [
      {
        title: "Global Language Learning Market",
        description: "$60 billion market size, targeting 50 million users",
        metrics: [
          { value: "$60B", label: "Global Market Size" },
          { value: "50M", label: "Target Users" },
          { value: "30,000", label: "Target Enterprise Clients" },
          { value: "20%", label: "Target Market Share" }
        ]
      },
      {
        title: "Global Expansion Plan",
        description: "Support 34 languages, reach 10 million active users within 10 years",
        metrics: [
          { value: "34", label: "Supported Languages" },
          { value: "10M", label: "Active User Target" },
          { value: "$1.5B", label: "Annual Revenue Target" },
          { value: "10 Years", label: "Global Deployment Timeline" }
        ]
      },
      {
        title: "AI Education Market Trends",
        description: "30% growth in digital learning post-COVID, AI education demand expected to reach $600 billion",
        metrics: [
          { value: "$600B", label: "AI Education Market Estimate" },
          { value: "30%", label: "Post-COVID Digital Learning Growth" },
          { value: "50%", label: "Traditional Learner Dropout Rate" },
          { value: "20%", label: "Annual User Growth Estimate" }
        ]
      }
    ],

    // Business Model
    business_title: "Innovative Business Model",
    business_subtitle: "Voice data monetization makes platform nearly free, creating flywheel effect for sustainable growth",
    business_models: [
      {
        title: "B2C Subscription Service",
        description: "$10/month, high-usage free clause (must meet data quality requirements)",
        pricing: "$10 USD/month",
        details: "Free if >5 hours usage with 80+ average score, data used for AI training"
      },
      {
        title: "B2B Enterprise Solutions",
        description: "Corporate employee training, full refund for 1000 hours high-quality data",
        pricing: "From $3,000 USD/year",
        details: "Customized features, management dashboard, analysis reports, full refund if targets met"
      },
      {
        title: "Teaching API Integration Service",
        description: "$6/month/student, 100% refund for 5 hours high-quality data",
        pricing: "$6 USD/month/student",
        details: "Teacher points rewards, seamless LMS system integration"
      },
      {
        title: "White Label Licensing",
        description: "Brand customization solutions, refund for 1000 hours data",
        pricing: "From $3,000 USD/year",
        details: "Brand customization, technical support, joint development"
      },
      {
        title: "Voice Data Sales",
        description: "Niche linguistic data sales, $100-500 per hour",
        pricing: "$100-500/hour",
        details: "Anonymized error pronunciation data, royalty or one-time sales model"
      }
    ],

    // Competitive Advantage
    competitive_title: "Core Competitive Advantages",
    competitive_subtitle: "Data-driven ecosystem creates unique moat, forming irreplicable competitive advantages",
    competitive_advantages: [
      {
        title: "Technical Barriers & Integration Advantages",
        description: "Azure deep integration, proprietary AI algorithms, 34-language support",
        points: [
          "Microsoft Azure deep integration and optimization",
          "Proprietary multi-modal AI algorithms",
          "34-language framework, expandable to 180+ countries",
          "Modular platform design ensures scalability"
        ]
      },
      {
        title: "Data Monetization Moat",
        description: "Unique voice data sales model creates sustainable revenue stream",
        points: [
          "High-quality niche error pronunciation data collection",
          "Anonymization processing compliant with privacy laws",
          "Data sales partnerships with AI companies",
          "Flywheel effect: Free users → Data → Revenue → More users"
        ]
      },
      {
        title: "User Experience & Ecosystem Advantages",
        description: "Intuitive interface, personalized learning paths, community interaction and refund incentives",
        points: [
          "Intuitive cross-platform interface design",
          "Personalized learning paths and smart recommendations",
          "Community sharing and collaborative learning mechanisms",
          "Refund incentive mechanisms boost user engagement"
        ]
      }
    ],

    // Partner Ecosystem
    ecosystem_title: "Strategic Partner Ecosystem",
    ecosystem_subtitle: "Building win-win partnerships to expand data collection and market reach",
    ecosystem_partners: [
      {
        title: "Educational Institution Partnerships",
        description: "Learning progress assessment system creating triple-win cooperation",
        benefits: [
          "$3-4/month/person learning progress plans",
          "Complete learning progress tracking",
          "Certification fees and data collection dual profits",
          "Help institutions improve teaching quality"
        ],
        revenue_model: "$3-4/month/person + Certification fees + Data sales"
      },
      {
        title: "API Partners",
        description: "Teacher embedding tools with points mall incentive mechanisms",
        benefits: [
          "Seamless integration into various LMS teaching systems",
          "Teacher points rewards incentivize adoption",
          "Student parents pay, teachers get rewards",
          "Boost platform adoption rate by 20%"
        ],
        revenue_model: "$6/month/student + Teacher points incentives"
      },
      {
        title: "Study Abroad/Immigration Agency Alliance",
        description: "15-30% commission sharing + smart recommendation system",
        benefits: [
          "Smart recommendations for suitable agency services",
          "Improve exam pass rates, increase customer satisfaction",
          "Commission sharing creates passive income",
          "Data supports precision marketing"
        ],
        revenue_model: "15-30% commission + Platform usage fees"
      },
      {
        title: "AI Company Partners",
        description: "Establish data sales cooperation with speechsuper.com and others",
        benefits: [
          "High-quality niche linguistic data sales cooperation",
          "Royalty or one-time sales models",
          "Cover Azure API costs",
          "Establish long-term data supply relationships"
        ],
        revenue_model: "Data sales royalties + Technology licensing"
      }
    ],

    // Financial Projections
    financial_title: "Financial Growth Projections",
    financial_subtitle: "Conservative three-year financial blueprint with data sales contributing 18% of revenue",
    financial_projections: [
      {
        year: "Year 1 (Launch)",
        description: "Build user base, launch data collection and sales mechanisms",
        metrics: [
          { value: "$12M", label: "Total Revenue" },
          { value: "100K", label: "Users" },
          { value: "$1.5M", label: "Data Sales Revenue" },
          { value: "25%", label: "Net Profit Margin" }
        ]
      },
      {
        year: "Year 2 (Growth)",
        description: "Expand market reach, optimize data monetization model",
        metrics: [
          { value: "$44M", label: "Total Revenue" },
          { value: "300K", label: "Users" },
          { value: "$9M", label: "Data Sales Revenue" },
          { value: "43%", label: "Net Profit Margin" }
        ]
      },
      {
        year: "Year 3 (Expansion)",
        description: "Global expansion, establish market leadership",
        metrics: [
          { value: "$125M", label: "Total Revenue" },
          { value: "1M", label: "Users" },
          { value: "$41M", label: "Data Sales Revenue" },
          { value: "50%", label: "Net Profit Margin" }
        ]
      }
    ],

    // Team
    team_title: "Founding Team",
    team_subtitle: "Composed of AI experts, speech engineers, and education innovators with rich product development experience",
    team_education_label: "Background:",
    team_experience_label: "Experience:",
    team_members: [
      {
        name: "Yichi Wang",
        role: "Founder & CEO",
        education: "AI Expert, Speech Technology Specialist",
        experience: "Language learning app development experience, AI speech assessment feature innovator"
      }
    ],

    // Call to Action
    cta_title: "Invest in the AI Education Revolution",
    cta_subtitle: "nicetone.ai is not just a learning platform, but a data-driven educational ecosystem. Investing in us means investing in the trillion-dollar opportunity of future education technology!",
    cta_button_primary: "Try Product Now",
    cta_button_secondary: "Contact for Investment"
  }
};